import { useQuery } from '@tanstack/react-query'

import {
  getOrganizationOptions,
  getUserOrganizationPermissionsOptions,
} from '@/client/@tanstack/react-query.gen'

export const useOrganization = (organizationId: string, opts = {}) => {
  return useQuery({
    ...getOrganizationOptions({ path: { organization_id: organizationId } }),
    ...opts,
  })
}

export const useGetOrganizationPermissions = (organizationId: string, opts = {}) => {
  return useQuery({
    ...getUserOrganizationPermissionsOptions({ path: { organization_id: organizationId } }),
    ...opts,
  })
}
